export const DASHBOARD = ["PORTAL.DASHBOARD"];

export const RESIDENTS = {
	$or: [
		"PORTAL.RESIDENT_OVERVIEW",
		"PORTAL.CARE",
		"PORTAL.RESIDENT_DOCUMENTS",
		"PORTAL.WOUNDCARE",
		"PORTAL.PERSONAL_INFORMATION",
		"PORTAL.SOCIAL_INFORMATION",
		"PORTAL.MEDICAL_INFORMATION",
		"PORTAL.ADMISSION_INFORMATION",
		"PORTAL.EARLY_CARE",
		"PORTAL.HISTORY_AND_GOALS",
		"PORTAL.CONTACTS_INFORMATION",
		"PORTAL.MEDICATION_PLANNING",
		"PORTAL.SHT",
		"PORTAL.CALENDAR",
		"PORTAL.CARE_REGISTRATIONS",
		"PORTAL.RESIDENT_DOCUMENTS",
		"PORTAL.BELRAI",
		"PORTAL.OBSERVATIONS",
		"PORTAL.FOLLOW_UP_PLANS",
	],
};

export const ORGANISATION = {
	$or: [
		"PORTAL.ORGANIZATION_OVERVIEW",
		"PORTAL.ORGANIZATION_HISTORY",
		"PORTAL.ALARMS",
		"PORTAL.ORGANISATION_STRUCTURE",
		"PORTAL.QUALITY_INDICATOR",
		"PORTAL.INTERNAL_EMPLOYEES",
		"PORTAL.EXTERNAL_EMPLOYEES",
		"PORTAL.MEDICATION",
		"PORTAL.ORGANIZATION_DOCUMENTS",
		"PORTAL.MDO",
		"PORTAL.CARE",
		"PORTAL.CALENDAR",
		"PORTAL.OBSERVATION_REPORTS",
	],
};
